import * as Sentry from "@sentry/react";
import { browserTracingIntegration, replayIntegration } from "@sentry/react";

const sentryUrl = process.env.REACT_APP_SENTRY_DSN;

Sentry.init({
  dsn: sentryUrl,
  integrations: [
    browserTracingIntegration(),
    replayIntegration()
  ],
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.REACT_APP_ENVIRONMENT
});